import React from 'react';
import { Grid, Typography, Box, Stack } from '@mui/material';
import {
  SmartToy as AiIcon,
  Groups as PeerIcon,
  VerifiedUser as ExpertIcon,
  School as CampusIcon,
} from '@mui/icons-material';
import SectionContainer from '../shared/SectionContainer';
import LandingCtaButton from '../shared/LandingCtaButton';
import { CANDIDATE_PILLARS } from '../landingContent';
import { LANDING_COLORS, LANDING_FONTS } from '../landingVisual';

const PILLAR_ICONS = [AiIcon, PeerIcon, ExpertIcon, CampusIcon];

const CandidatePillarsSection = () => (
  <SectionContainer
    id="prep-pillars"
    title="Ways to Prepare"
    subtitle="AI practice, peers, experts, and campus / SSB-style prep — choose what fits your goals."
    titleId="prep-pillars-heading"
    bgcolor={LANDING_COLORS.mist}
    py={{ xs: 7, md: 9 }}
  >
    <Grid container spacing={2.5}>
      {CANDIDATE_PILLARS.map((pillar, index) => {
        const Icon = PILLAR_ICONS[index] || CampusIcon;
        return (
          <Grid item xs={12} sm={6} lg={3} key={pillar.title}>
            <Box
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                p: { xs: 2.5, md: 3 },
                borderRadius: 2,
                border: '1px solid',
                borderColor: LANDING_COLORS.line,
                bgcolor: 'background.paper',
                fontFamily: LANDING_FONTS.sans,
                transition: 'border-color 160ms ease, transform 160ms ease',
                '&:hover': {
                  borderColor: 'primary.light',
                  transform: 'translateY(-2px)',
                },
              }}
            >
              <Stack
                alignItems="center"
                justifyContent="center"
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: 1.5,
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  mb: 2,
                }}
              >
                <Icon sx={{ fontSize: 24 }} aria-hidden="true" />
              </Stack>
              <Typography
                variant="h6"
                component="h3"
                sx={{ fontWeight: 700, mb: 1, letterSpacing: '-0.02em', fontFamily: LANDING_FONTS.sans }}
              >
                {pillar.title}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 3, flex: 1, lineHeight: 1.7, fontFamily: LANDING_FONTS.sans }}
              >
                {pillar.description}
              </Typography>
              <LandingCtaButton
                to={pillar.cta.to}
                label={pillar.cta.label}
                variant={pillar.cta.variant}
                fullWidth
              />
            </Box>
          </Grid>
        );
      })}
    </Grid>
  </SectionContainer>
);

export default CandidatePillarsSection;
